'use client';

import { EntryCardsFragment } from '@/__generated__/graphql';
import { ENTRY_CARDS_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { useFragment } from '@apollo/client';
import { SearchCard } from '../Cards/SearchCard';

export default function SearchResult({ id, typeName }: { id: string; typeName: string }) {
  const { data } = useFragment({
    fragment: ENTRY_CARDS_FRAGMENT,
    fragmentName: 'entryCards',
    from: { id, __typename: typeName },
  });

  return <SearchCard {...(data as EntryCardsFragment)} />;
}
